import { canExposePilotSurface, type PilotSurfaceId } from "@enrein/shared-contracts/pilot-exposure";
export const V10_VIEWS = ["today", "projects", "portfolio", "inbox", "scans", "settings", "project"] as const;

export type V10View = (typeof V10_VIEWS)[number];

export const V10_SIDEBAR_VIEWS = ["today", "projects", "portfolio", "inbox", "scans", "settings"] as const;

export type V10SidebarView = (typeof V10_SIDEBAR_VIEWS)[number];

export function isV10View(value: string): value is V10View {
  return (V10_VIEWS as readonly string[]).includes(value);
}

export const V10_VIEW_META: Record<V10View, { readonly title: string; readonly subtitle: string }> = {
  today: {
    title: "Today",
    subtitle: "Start work, continue projects, and clear what is blocked.",
  },
  projects: {
    title: "Projects",
    subtitle: "Every client opens into one Project Control Room.",
  },
  portfolio: {
    title: "Portfolio",
    subtitle: "Launched sites, health, client requests, and modernization opportunities.",
  },
  inbox: {
    title: "Client Portal",
    subtitle: "Agency inbox for client requests and review actions.",
  },
  scans: {
    title: "Scans / Proof",
    subtitle: "Relaunch scans and external proof intake.",
  },
  settings: {
    title: "Settings",
    subtitle: "Agency identity and system rules.",
  },
  project: {
    title: "Project Control Room",
    subtitle: "One room from setup through handoff.",
  },
};


const V10_VIEW_SURFACES: Record<V10View, PilotSurfaceId> = {
  today: "studio.view.today",
  projects: "studio.view.projects",
  portfolio: "studio.view.portfolio",
  inbox: "studio.view.inbox",
  scans: "studio.view.scans",
  settings: "studio.view.settings",
  project: "studio.view.project",
};

export function isV10ViewExposed(view: V10View): boolean {
  return canExposePilotSurface(V10_VIEW_SURFACES[view], "agency", {
    deployEnv: import.meta.env.VITE_ENREIN_DEPLOY_ENV,
    nodeEnv: import.meta.env.MODE,
    explicitFlags: import.meta.env.VITE_ENREIN_PILOT_FEATURE_FLAGS,
  }).enabled;
}

export function exposedV10SidebarViews(): readonly V10SidebarView[] {
  return V10_SIDEBAR_VIEWS.filter(isV10ViewExposed);
}
